import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { deleteWithToken, getLocalStorage, getWithToken, patchAvtarWithToken, patchWithToken, setLocalStorage } from '../API/Api';
import { validateEmail, validName } from '../assets/Helper/utils';
import Loader from '../components/Loader';
import { FiUpload } from 'react-icons/fi';
import SAVE_ICON from '../assets/icons/ComniqaiIcon-V3.0/save-icon.svg';
import { RxExclamationTriangle } from 'react-icons/rx';
import CustomPopUp from '../components/CustomPopUp';
import SubContext from '../contexts/SubContext';
import { FiDownload } from 'react-icons/fi';
import { getPlanLevel, PLAN_LEVELS } from '../API/Constant';
import { ProgressContext } from '../contexts/ProgressContext';

const ValidationErrors = {
  empty: {
    first_name: 'First Name is Required.',
    last_name: 'Last Name is Required',
    email: 'Email is Required',
  },
  invalid: {
    first_name: 'Invalid name',
    last_name: 'Invalid name',
    email: 'Invalid Email',
  },
};

const DangerCard = ({ title, description, onClick, color }) => (
  <div className='col-12 col-md-6'>
    <div className='p-3 mt-3 rounded bg-light' style={{ border: `2px solid ${color}` }}>
      <h6 className='outfit-semibold' style={{ color: color }}>
        {title}
      </h6>
      <p className='outfit-regular mb-3'>{description}</p>
      <button className='chatbot-save-btn outfit-medium d-flex align-items-center gap-2' style={{ background: color }} onClick={onClick}>
        {title}
      </button>
    </div>
  </div>
);

const BillingDetails = ({ billingHistory, subscriptionInfo, subsUserInfo, navigate, billingLoader, planLevel }) => {
  const [tooltipData, setTooltipData] = useState({ visible: false, content: '', x: 0, y: 0 });
  const handleMouseEnter = (e, summary) => {
    const { clientX: x, clientY: y } = e;
    setTooltipData({ visible: true, content: summary, x, y });
  };

  const handleMouseLeave = () => {
    setTooltipData({ visible: false, content: '', x: 0, y: 0 });
  };
  return (
    <div className='setting-card-section mt-4'>
      <div className='setting-card-text'>
        <h5 className='outfit-semibold mb-0'>Billing Details</h5>
        <p className='outfit-regular'>Manage your subscription and payment details here.</p>
      </div>

      <div className='row g-4 align-items-start mt-3'>
        {/* Current Plan */}
        <div className='col-12 col-md-6'>
          <div className='p-3 rounded bg-light border'>
            <p className='outfit-bold mb-1'>
              {subscriptionInfo?.name ?? 'Free'} Plan —{' '}
              <span className='outfit-medium'>
                ${subscriptionInfo?.price ?? '0'}/{subscriptionInfo?.interval === 'month' ? 'month' : subscriptionInfo?.interval === 'year' ? 'year' : 'month'}
              </span>
            </p>

            {subsUserInfo?.billing_end_date && (
              <p className='outfit-bold text-muted font16 mb-2'>
                {subsUserInfo?.is_pending_cancellation ? 'Plan Expiry Date' : 'Next billing date'}:{' '}
                <span className='outfit-medium'>
                  {/* {new Date(subsUserInfo.billing_end_date).toLocaleDateString(undefined, {
                    day: 'numeric',
                    month: 'short',
                    year: 'numeric',
                  })} */}
                  {subsUserInfo.billing_end_date}
                </span>
              </p>
            )}
            {subsUserInfo?.card_info && (
              <p className='outfit-bold text-muted font16 mb-2'>
                Payment Method: <span className='outfit-medium'> {subsUserInfo?.card_info}</span>
              </p>
            )}

            {planLevel < PLAN_LEVELS.Pro && (
              <button className='chatbot-save-btn outfit-medium' onClick={() => navigate('/pricing')}>
                Upgrade
              </button>
            )}
          </div>
        </div>

        {/* Payment Method */}
        {/* <div className='col-12 col-md-6'>
          <div className='p-3 rounded bg-light border'>
            <h6 className='outfit-semibold mb-1'>Payment Method</h6>
            <p className='outfit-regular mb-2'>Visa ending in **** 4242</p>
            <button className='chatbot-save-btn outfit-medium' onClick={() => navigate('/pricing')}>
              Update Card
            </button>
          </div>
        </div> */}

        {/* Billing History */}
        <div className='custom-table-container p-0 mt-4'>
          <h5 className='outfit-semibold m-3'>Billing History</h5>
          <div className='table-responsive'>
            <table className='table table-hover table-bordered align-middle mb-0'>
              <thead className='table-light'>
                <tr>
                  <th>Date</th>
                  <th>Amount</th>
                  <th>Plan</th>
                  <th className='text-center'>Status</th>
                  <th className='text-center'>Subscription Period</th>
                  <th className='text-center'>Payment Method</th>
                  <th className='text-center'>Invoice</th>
                </tr>
              </thead>
              <tbody>
                {billingLoader ? (
                  <tr>
                    <td colSpan='7' className='outfit-medium font16 text-center py-3'>
                      Loading...
                    </td>
                  </tr>
                ) : billingHistory?.length > 0 ? (
                  billingHistory?.map((item, idx) => (
                    <tr key={idx}>
                      <td>{item.date}</td>

                      <td>${item.amount || '0'}</td>
                      <td>{item.subscription_plan_name}</td>
                      <td className='text-center'>
                        <span
                          className={`badge position-relative ${['paid', 'success'].includes(item?.status?.toLowerCase()) ? 'bg-success' : 'bg-danger'}`}
                          style={{ padding: '0.4rem 0.7rem', fontSize: '0.85rem', cursor: item?.failure_reason ? 'pointer' : 'default' }}
                          onMouseEnter={(e) => {
                            if (item?.failure_reason) {
                              handleMouseEnter(e, item.failure_reason);
                            }
                          }}
                          onMouseLeave={() => {
                            if (item?.failure_reason) {
                              handleMouseLeave();
                            }
                          }}
                        >
                          {item?.status?.charAt(0).toUpperCase() + item?.status?.slice(1)}
                        </span>
                        {tooltipData.visible && item?.failure_reason && (
                          <div
                            className='custom-table-tooltip'
                            style={{
                              position: 'fixed',
                              top: tooltipData.y + 30,
                              left: tooltipData.x + 30,
                            }}
                          >
                            {tooltipData.content}
                          </div>
                        )}
                      </td>
                      <td className='text-center'>
                        {['paid', 'success'].includes(item?.status?.toLowerCase()) && item?.cycle_start && item?.cycle_end ? `${item.cycle_start} - ${item.cycle_end}` : '-'}
                      </td>
                      <td className='text-center'>{item?.payment_method || '-'}</td>
                      <td className='text-center'>
                        {['paid', 'success'].includes(item?.status?.toLowerCase()) && item.download_invoice_url ? (
                          <a
                            href={item.download_invoice_url}
                            target='_blank'
                            rel='noopener noreferrer'
                            className='d-inline-flex align-items-center justify-content-center gap-2'
                            title='Download Invoice'
                          >
                            <FiDownload size={18} />
                          </a>
                        ) : (
                          '-'
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan='7' className='text-center py-3'>
                      No Billing History Available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

const UserProfile = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [apiTokenData, setApiTokenData] = useState('');
  const [userId, setUserId] = useState('');
  const [deleteAllPopUpOpen, setDeleteAllPopUpOpen] = useState(false);
  const [deleteAccountPopUpOpen, setDeleteAccountPopUpOpen] = useState(false);
  const fileInputRef = useRef(null);
  const [avatar, setAvatar] = useState(null);
  const [values, setValues] = useState({
    first_name: '',
    last_name: '',
    email: '',
    organization_name: '',
  });
  const [errors, setErrors] = useState({
    first_name: '',
    last_name: '',
    email: '',
  });
  const { first_name, last_name, email, organization_name } = values;
  const [billingHistory, setBillingHistory] = useState([]);
  const [billingLoader, setBillingLoader] = useState(false);
  const { stopPolling } = useContext(ProgressContext);
  const subsFlag = useContext(SubContext);
  const subscriptionInfo = subsFlag?.subscriptionFlag?.user?.subscription ?? null;
  const subsUserInfo = subsFlag?.subscriptionFlag?.user ?? null;

  const subscriptionName = subscriptionInfo?.name ?? 'Free';
  const planLevel = useMemo(() => getPlanLevel(subscriptionName), [subscriptionName]);

  useEffect(() => {
    let token = getLocalStorage('apiToken');
    if (token) {
      setApiTokenData(JSON.parse(token));
      getUserProfileDetails(JSON.parse(token));
      fetchBillingHistory(JSON.parse(token));
      subsFlag?.setUpdateValue('1');
    } else {
      navigate('/login');
    }
  }, [navigate]);

  const userHandleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const getUserProfileDetails = (token) => {
    setLoader(true);
    getWithToken('userprofile/', token)
      .then((response) => {
        if (response.status === 200) {
          setUserId(response?.data?.id);
          setValues({
            ...values,
            first_name: response?.data?.first_name,
            last_name: response?.data?.last_name,
            email: response?.data?.email,
            organization_name: response?.data?.organization_name || '',
          });
          setAvatar(response?.data?.profile_image);
        }
      })
      .catch((error) => {
        toast.error('Something went wrong');
      })
      .finally(() => {
        setLoader(false); // always executes
      });
  };

  const fetchBillingHistory = async (token) => {
    try {
      setBillingLoader(true);
      const res = await getWithToken('billing_history', token);
      if (res.status === 200) {
        setBillingHistory(res.data || []);
      } else {
        console.error(res.message || 'Failed to fetch billing history');
      }
    } catch (err) {
      console.error(err);
    } finally {
      setBillingLoader(false);
    }
  };

  const userHandleClick = () => {
    const tempErrors = { ...errors };
    Object.keys(values).forEach((key) => {
      if (!values[key]) {
        tempErrors[key] = ValidationErrors.empty[key];
      } else {
        if (key === 'first_name' && !validName(values[key])) {
          tempErrors.first_name = ValidationErrors.invalid.first_name;
        }
        if (key === 'last_name' && !validName(values[key])) {
          tempErrors.last_name = ValidationErrors.invalid.last_name;
        }
        if (key === 'email' && !validateEmail(values[key])) {
          tempErrors.email = ValidationErrors.invalid.email;
        }
      }
    });
    setErrors(tempErrors);

    if (Object.values(tempErrors).filter((obj) => !!obj).length > 0) {
      return false;
    }
    setLoader(true);
    if (userId) {
      patchWithToken('userprofile/' + userId + '/', apiTokenData, values)
        .then((response) => {
          if (response.status === 200) {
            setLocalStorage('FullName', response?.data?.first_name + ' ' + response?.data?.last_name);
            toast.success(response.message);
          } else {
            toast.error(response.message);
          }
        })
        .catch((error) => {
          toast.error('Something went wrong');
        })
        .finally(() => {
          setLoader(false); // always executes
        });
    }
  };

  const handleDeleteAction = async (type) => {
    setLoader(true);
    const endpoint = type === 'data' ? 'Content_DeleteAPI/' : 'account_delete';

    try {
      const response = await deleteWithToken(endpoint, apiTokenData);

      if (response.status === 200) {
        toast.success(type === 'data' ? response.message : 'Your account and all associated data have been permanently deleted.');
        subsFlag.setUpdateValue('1');
        type === 'data' ? setDeleteAllPopUpOpen(false) : setDeleteAccountPopUpOpen(false);
        if (type === 'account') {
          localStorage.clear();
          navigate('/login');
        }
        stopPolling();
        window.location.reload();
      } else {
        toast.error(response.message || 'Something went wrong.');
      }
    } catch (error) {
      toast.error('Something went wrong. Please try again later.');
    } finally {
      setLoader(false);
    }
  };

  const handleAvatarClick = () => {
    fileInputRef.current.click();
  };

  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imgUrl = URL.createObjectURL(file);
      setAvatar(imgUrl);

      const formData = new FormData();
      formData.append('profile_image', file);

      setLoader(true);

      patchAvtarWithToken(`update-profile-image`, apiTokenData, formData)
        .then((res) => {
          if (res) {
            let user = JSON.parse(localStorage.getItem('userDetails'));
            user.profile_image = res?.profile_image;
            localStorage.setItem('userDetails', JSON.stringify(user));
            window.location.reload();
            toast.success('Avatar updated successfully!');
          } else {
            toast.error('Failed to update avatar.');
          }
          setLoader(false);
        })
        .catch((err) => {
          toast.error('Upload failed');
          console.error(err);
          setLoader(false);
        });
    }
  };

  return (
    <div className='container'>
      <div className='row m-0 mt-4 ps-md-4 ps-sm-4 ps-4 pe-md-4 pe-sm-4 pe-4 mb-4'>
        <div className='comniq-container mt-3'>
          <div className='setting-card-section'>
            <div className='setting-card-text'>
              <h5 className='outfit-semibold mb-0'>Profile Information</h5>
              <p className='outfit-regular'>Update your account details and profile information.</p>
            </div>

            <div className='row g-4 align-items-start mt-4'>
              <div className='col-12 col-md-3 text-center m-o'>
                <div className='profile-avatar mx-auto mb-4'>
                  {avatar ? (
                    <img src={avatar} alt='Avatar' className='img-fluid rounded-circle' />
                  ) : (
                    <div
                      className='rounded-circle text-white d-flex align-items-center justify-content-center m-auto mb-2'
                      style={{ width: '80px', height: '80px', minWidth: '80px', minHeight: '80px', fontSize: '25px', background: '#dc5385' }}
                    >
                      {first_name
                        ?.split(' ')
                        .map((n) => n[0])
                        .join('')}
                    </div>
                  )}
                </div>
                <button className='btn-add-faq outfit-medium' onClick={handleAvatarClick}>
                  <FiUpload className='me-2' /> Change Avatar
                </button>
                <input type='file' ref={fileInputRef} accept='image/*' style={{ display: 'none' }} onChange={handleAvatarChange} />
              </div>

              <div className='col-12 col-md-9 m-0'>
                <form>
                  <div className='row chatbox-field'>
                    <div className='col-12 col-md-6 mb-3'>
                      <div className='chatbox-input-text input-GPT new mb-3'>
                        <label className='outfit-medium'>First Name*</label>
                        <div className='chatbox-input-field'>
                          <input
                            type='text'
                            placeholder='John'
                            className='form-control chatbox-input box-shadow-hover'
                            name='first_name'
                            value={first_name}
                            autoComplete='off'
                            onChange={userHandleChange}
                          />
                          <div className='chat-error'>{errors.first_name && <span className='text-danger insta-smart-error'>{errors.first_name}</span>}</div>
                        </div>
                      </div>
                    </div>
                    <div className='col-12 col-md-6 mb-3'>
                      <div className='chatbox-input-text input-GPT new mb-3'>
                        <label className='outfit-medium'>Last Name*</label>
                        <div className='chatbox-input-field'>
                          <input
                            type='text'
                            placeholder='Luna Design Agent'
                            className='form-control chatbox-input box-shadow-hover'
                            name='last_name'
                            value={last_name}
                            autoComplete='off'
                            onChange={userHandleChange}
                          />
                          <div className='chat-error'>{errors.last_name && <span className='text-danger insta-smart-error'>{errors.last_name}</span>}</div>
                        </div>
                      </div>
                    </div>
                    <div className='col-12 col-md-6 mb-3'>
                      <div className='chatbox-input-text input-GPT new mb-3'>
                        <label className='outfit-medium'>Email Address*</label>
                        <div className='chatbox-input-field user-profile-email'>
                          <input
                            type='text'
                            placeholder='John'
                            className='form-control chatbox-input box-shadow-hover opacity-50 cursor-not-allowed'
                            name='email'
                            value={email}
                            autoComplete='off'
                            onChange={userHandleChange}
                            disabled
                            style={{ cursor: 'not-allowed' }}
                          />

                          <div className='chat-error'>{errors.email && <span className='text-danger insta-smart-error'>{errors.email}</span>}</div>
                        </div>
                      </div>
                    </div>
                    <div className='col-12 col-md-6 mb-3'>
                      <div className='chatbox-input-text input-GPT new mb-3'>
                        <label className='outfit-medium'>Organization Name</label>
                        <div className='chatbox-input-field'>
                          <input
                            type='text'
                            placeholder='Enter your organization name here'
                            className='form-control chatbox-input box-shadow-hover'
                            name='organization_name'
                            value={organization_name}
                            autoComplete='off'
                            onChange={userHandleChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className=' d-flex align-items-center justify-content-end'>
                    <button className='chatbot-save-btn outfit-medium d-flex align-items-center gap-2' type='button' onClick={userHandleClick}>
                      <img src={SAVE_ICON} alt='save-icon' /> Save Profile
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <BillingDetails
            billingHistory={billingHistory}
            subscriptionInfo={subscriptionInfo}
            subsUserInfo={subsUserInfo}
            navigate={navigate}
            billingLoader={billingLoader}
            planLevel={planLevel}
          />

          {/* <div className='setting-card-section mt-4'>
            <div className='setting-card-text'>
              <h5 className='outfit-semibold mb-0 text-danger'>
                <RxExclamationTriangle className='me-2' />
                Danger Zone
              </h5>
              <p className='outfit-regular'>These actions are irreversible. Proceed with caution.</p>
            </div>
            <div className='row g-4 align-items-start'>
              <DangerCard
                title='Clear All Data'
                description='This will permanently remove all your stored data including history, settings, and preferences.'
                onClick={() => setDeleteAllPopUpOpen(true)}
                color='#e8590c'
              />
              <DangerCard
                title='Delete Account'
                description='This will permanently delete your account and all associated information. You won’t be able to recover it.'
                onClick={() => setDeleteAccountPopUpOpen(true)}
                color='#dc3545'
              />
            </div>
          </div> */}

          {loader && (
            <div className='loader-center'>
              <Loader />
            </div>
          )}
          {deleteAllPopUpOpen && (
            <CustomPopUp
              title="You're about to delete your data?"
              onConfirm={() => handleDeleteAction('data')}
              onClose={() => setDeleteAllPopUpOpen(false)}
              confirmText='Delete'
              closeText='Cancel'
              variant='error1'
              initialWidth='500px'
              loader={loader}
            >
              <p className='outfit-regular'>Your Company Profile, FAQ’s and Bot Messages will be permanently deleted. You won't be able to see them again.</p>
            </CustomPopUp>
          )}

          {deleteAccountPopUpOpen && (
            <CustomPopUp
              title="You're about to delete your account?"
              onConfirm={() => handleDeleteAction('account')}
              onClose={() => setDeleteAccountPopUpOpen(false)}
              confirmText='Delete'
              closeText='Cancel'
              variant='error'
              initialWidth='500px'
              loader={loader}
            >
              <p className='outfit-regular'>
                This action will permanently delete your entire account, including your company profile, FAQs, and bot messages. This data cannot be recovered once deleted. Are you
                sure you want to proceed?
              </p>
            </CustomPopUp>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
